import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Map } from "immutable";
import { Table } from "antd";
import {
    Row,
    Col,
    Layout,
    Button,
    Modal,
    Divider,
    Checkbox,
    Input,
    Select,
    Alert,
    Icon,
    Tooltip,
    Form,
    message
} from "antd";
import DocumentViewList from "./document-view-list";
import SignzyDataForm from "./../../forms/signzy-data-form";
import { List } from "immutable";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
import {
    uploadDocument,
    uploadDocuments,
    fetchCompanyDocuments,
    updateDocument,
    fetchApplicantsList,
    fetchDocumentTypes,
    invalidateDocument,
    requestDocuments,
    validateDocument,
    attachDocument,
    failedValidateDocument,
    failedInvalidateDocumentStatus,
    parseDocument,
    sendRequest,
    addRequestRemarks,
    fetchCaseDetail,
    fetchCaseAssociates,
    fetchDocumentsCaseV2
} from "store/actions";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { UI_PERMISSIONS, STATE_STATUS } from "constants/index";
import "styles/document-review.css";
import CompanyService from "services/company-service";
let scrollPositionValue = 0;
const {TextArea} = Input;
const FormItem = Form.Item;
const applicantDocuments = {
    7 : "Pan Card",
    6 : "Photograph",
    63 : "Aadhar Card M",
};

const otherDocuments = {
    46 : "Others"
};

const applicantAadharBoth = {
    "63-12" : "Aadhar - Front",
    "63-13" : "Aadhar - Back"
}; 

class DocumentReviewTabV2 extends React.PureComponent {
    state = {
        selectedFilePath: null,
        selectedFileType: null,
        selectedFile: null,
        openDrawer: false,
        fileName: null,
        docMaster: new List([]),
        requestedDocs: [],
        showRequestedRemarks: false,
        requestedRemarks: null,
        searchFilterVals: null,
        applicantSelectModal : false,
        requestedApplicantDocs : [],
        document : [],
        filteredAadharBoth : [],
        showAddCustomerStatus: false,
        showAddCustomerText: null,
        vkycStatus: "Yet to Initiate",
        showEmailStatus: false,
        showEmailText: null,
        vkycTransactionId: null,
        showVkycDetail: false,
        vkycViewData: {},
        isVkycRequired: false,
        vkycViewDetail: {},
        filterOtherDocuments : [],
        isGeneratingLink: {},
        selectedAgent: {},
        selectedCaller: {},
        vkycUsers: [],
        agentName: {}
    };

    async handleFetchDocumentMasterList() {
        if (this.props.docMasterListStatus == STATE_STATUS.UNFETCHED) {
            this.props.fetchDocumentTypes();
        }
    }

    async handleFetchApplicantList() {
        if (this.props.associatesStatus == STATE_STATUS.UNFETCHED) {
            this.props.fetchApplicantsList(this.props.companyId);
        }
    }

    async handleFilesFetch(forceUpdate = false) {
        const t = this;
        if (
            t.props.companyId &&
            (t.props.filesStatus === STATE_STATUS.UNFETCHED || forceUpdate)
        ) {
            t.props.fetchDocumentsCaseV2(
                t.props.caseId,
                t.props.companyId,
            );
        }
    }

    componentDidMount() {
        this.handleFetchDocumentMasterList();
        this.handleFilesFetch();
        this.handleFetchApplicantList();
        this.createRequestDocIdList();
        this.handleScrollPosition();
        CompanyService.getCorporateRelationshipManager("Vkyc").then(res => {
            this.setState({vkycUsers: res.data && res.data?.results});
        }).catch(err=>{
            message.error("Something went wrong");
        })
        // CompanyService.vkycGetData(73467).then(({data})=>{
        // CompanyService.vkycGetData(this.props.caseId).then(({data})=>{
        //     this.setState({
        //         vkycTransactionId: data?.results[0]?.transaction_id,
        //         vkycViewData: data?.results[0]?.json_data,
        //         isVkycRequired: data?.results[0]?.is_vkyc_required,
        //         vkycViewDetail: data?.results[0]
        //     });
        //     if(data.results[0]?.call_status !== null){
        //         this.setState({
        //             vkycStatus: data.results[0]?.call_status
        //         });
        //     }
        // });
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.docMasterList &&
            (this.props.docMasterList.length ||
                this.props.docMasterList.size) &&
            !this.state.isDocumentFetched
        ) {
            this.setState({
                docMaster: this.props.docMasterList,
                isDocumentFetched: true
            });
        }
        if(prevProps.companyDocStatusPrevios?.toJS().companyDocStatus != "FETCHED" &&this.props.companyDocStatusPrevios?.toJS().companyDocStatus === "FETCHED"){
            this.callCaseDetailsFn("approve");
            this.props.fetchDocumentsCaseV2(
                this.props.caseId,
                this.props.companyId,
            );      
            this.props.failedValidateDocument();
        }
        if(prevProps.companyDocStatusPrevios?.toJS().deletedCompanyDocuments != "FETCHED" &&this.props.companyDocStatusPrevios?.toJS().deletedCompanyDocuments === "FETCHED"){
            this.props.fetchDocumentsCaseV2(
                this.props.caseId,
                this.props.companyId,
            );
            this.callCaseDetailsFn("delete");
        }
        this.createRequestDocIdList();
    }
    handleScrollPosition = () => {
        const scrollPosition = sessionStorage.getItem("scrollPosition");
        const searchFilterVals = sessionStorage.getItem("searchFilterVals");
        const scrollPositionDocReview = sessionStorage.getItem("scrollPositionDocReview");
        if (scrollPositionDocReview) {
            document.getElementsByClassName("case-detail-row-scroll")[0]?.scrollTo({top:parseInt(scrollPosition), behavior: 
                "smooth" 
            });
            sessionStorage.removeItem("scrollPositionDocReview");
        }
        if (scrollPosition) {
            document.getElementsByClassName("doc-list-view-scroll")[0].scrollTo({top:parseInt(scrollPosition), behavior: 
            "smooth" 
            });
            sessionStorage.removeItem("scrollPosition");
        }
        if (searchFilterVals) {
            this.setState({searchFilterVals: searchFilterVals?.split(",")});
            sessionStorage.removeItem("searchFilterVals");
        }
    };
    // shouldComponentUpdate(nextProps, nextState) {
    //     if(
    //         this.props.associatesStatus !== nextProps.associatesStatus ||
    //         this.props.filesStatus !== nextProps.filesStatus ||
    //         this.props.files !== nextProps.files ||
    //         this.state.selectedFile !== nextState.selectedFile ||
    //         this.state.selectedFilePath !== nextState.selectedFilePath
    //     ) {
    //         return true;
    //     }
    //     return false;
    // }

    createRequestDocIdList() {
        if(this.props.files&&this.props.files.size>0 && this.state.requestedDocs.length === 0) {
            const isAlreadyRequested =
            (this.props.files &&
                this.props.files
                    .filter(
                        _ =>
                            _.document_status ===
                            DOCUMENT_CURRENT_STATUS.get("Requested")
                    )
                    .map(_ => _.document&&_.document.id)
                    .toMap()
                    .mapEntries(([, v]) => [v,v])
                    .toList()
                    .toArray()) ||
                [];
            if(isAlreadyRequested.length) {
                // this.setState({
                //     requestedDocs: isAlreadyRequested
                // });
            }
        }
    }

    viewDoc = file => {
        const filePath = file.file;
        const fileNameArr = (file.file && file.file.split("/").reverse()[0].split(".")) || [];
        const fileType = fileNameArr.reverse()[0];

        this.setState(
            {
                selectedFileType: file.file_mime_type && file.file_mime_type !== "application/x-empty" ? file.file_mime_type : fileType,
                selectedFilePath: filePath,
                selectedFile: file,
                fileName: file.file_name
            },
            () => this.forceUpdate()
        );
    };

    callCaseDetailsFn = (arg) => {
        CompanyService.allDocumentsReviewed(this.props.caseId).then(({data})=>{
            let docsStatus =  data.is_all_mandatory_document_verified; 
            if(arg === "approve" && docsStatus){
                sessionStorage.setItem("scrollPosition", scrollPositionValue);
                this.state.searchFilterVals != null && sessionStorage.setItem("searchFilterVals", this.state.searchFilterVals);
                this.props.fetchCaseDetail(this.props.caseId);
            }else if(arg === "delete" && !docsStatus){
                sessionStorage.setItem("scrollPosition", scrollPositionValue);
                this.state.searchFilterVals != null && sessionStorage.setItem("searchFilterVals", this.state.searchFilterVals);
                this.props.fetchCaseDetail(this.props.caseId);
                this.props.failedInvalidateDocumentStatus();
            }
        });
    }
    updateDocument = (action, file, associate, address, bankAccount) => {
        switch (action) {
        case "APPROVE":
            this.props.validateDocument(
                this.props.companyId,
                this.props.caseId,
                file,
                associate,
                address,
                bankAccount
            );
            break;
        case "REJECT":
            this.props.invalidateDocument(
                this.props.companyId,
                this.props.caseId,
                file,
            );
            break;
        case "DELETE":
            this.props.invalidateDocument(
                this.props.companyId,
                this.props.caseId,
                file,
            );
            this.setState({
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null
            });
            break;
        default:
            break;
        }
        /*eslint-enable*/
    };

    deleteRequestedDocument = (docId, document) => {
        this.props.invalidateDocument(
            this.props.companyId,
            docId,
            document.merge({
                is_active: false
            }),
            this.props.caseId
        );
        this.setState(
            {
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null
            });
    };

    addRequestedRemark = (docId, document) => {
        this.setState({
            selectedFile: document,
            showRequestedRemarks: true,
            requestedRemarks: document.request_remarks
        });
    };

    sendRequestToDocument = () => {
        this.props.addRequestRemarks(
            this.props.companyId,
            this.state.selectedFile.id,
            this.state.selectedFile.merge({
                request_remarks: this.state.requestedRemarks
            }),
            this.props.caseId
        );
        this.setState(
            {
                selectedFilePath: null,
                selectedFileType: null,
                selectedFile: null,
                fileName: null,
                requestedRemarks: null,
                showRequestedRemarks: false
            });
    }

    toggleDrawer = () => {
        this.setState({
            openDrawer: !this.state.openDrawer
        });
    };

    onKeyUp = e => {
        if (this.state.selectedFile) {
            const keyCode = e.keyCode;

            const currentFileIndex = this.props.files.findIndex(
                _ => _ && _.id === this.state.selectedFile.id
            );

            if (keyCode === 38) {
                if (currentFileIndex > 0) {
                    this.viewDoc(this.props.files
                        .filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                        .sort((a, b) => {
                            if(a.id > b.id) {
                                return -1;
                            }
                            if(a.id < b.id) {
                                return 1;
                            }
                            if(a.id === b.id) {
                                return 0;
                            }
                        })
                        .get(currentFileIndex - 1));
                }
            }
            if (keyCode === 40) {
                if (currentFileIndex < this.props.files.size - 1) {
                    this.viewDoc(this.props.files
                        .filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                        .sort((a, b) => {
                            if(a.id > b.id) {
                                return -1;
                            }
                            if(a.id < b.id) {
                                return 1;
                            }
                            if(a.id === b.id) {
                                return 0;
                            }
                        })
                        .get(currentFileIndex + 1));
                }
            }
        }
    };

    invalidateDoc = () => {
        this.props.invalidateDocument(
            this.props.companyId,
            this.state.selectedFile && this.state.selectedFile.id,
            this.state.selectedFile
                .set("remarks", this.state.remarks)
                .set("file_name", this.state.fileName),
            this.props.caseId
        );
    };

    changeName = file => {
        this.props.validateDocument(
            this.props.companyId,
            null,
            file
        );
    };

    getDocumentType = () => {
        if (
            this.state.fileName &&
            this.state.fileName.toLowerCase().includes("adhar")
        ) {
            return "aadhaar";
        }
        if (
            this.state.fileName &&
            this.state.fileName.toLowerCase().includes("pan")
        ) {
            return "pan";
        }
        return null;
    };

    openRequestModal = () => {
        this.setState({
            requestModal: true
        });
    };

    closeRequestModal = () => {
        this.setState({
            requestModal: false,
            requestDocSearchQuery: null
        });
    };

    onChangeRequestDocs=(val) => {
        this.setState({
            requestedDocs: val
        });
    };

    requestDocumentsHandler=() => {
        let filteredApplicantDocs = this.state.requestedDocs.filter(_ => applicantDocuments[_]);
        let filteredAadharBoth = this.state.requestedDocs.filter(_ => applicantAadharBoth[_]);
        let filterOtherDocuments = this.state.requestedDocs.filter(_ => otherDocuments[_]);
        if(filteredApplicantDocs.length > 0 || filteredAadharBoth.length > 0){
            this.setState({
                applicantSelectModal : true,
                requestedApplicantDocs : filteredApplicantDocs,
                filteredAadharBoth : filteredAadharBoth,
                filterOtherDocuments : filterOtherDocuments,
            });
        }else if(filterOtherDocuments.length > 0){
            this.setState({
                filterOtherDocuments : filterOtherDocuments,
                applicantSelectModal : true,
            });
        } else{
            const newDocs=Object.assign([],this.state.requestedDocs);
            this.setState(
                {
                    requestModal: false,
                    requestedDocs: []
                },
                () => {
                    this.props.requestDocuments(
                        this.props.caseId,
                        this.props.companyId,
                        newDocs
                    );
                }
            );
        } 
    };

    parseDocument = (file, docType) => {
        this.props.parseDocument(
            file,
            docType.toLowerCase()
        );
    };

    sendNotification = () => {
        this.props.sendRequest(this.props.caseId);
    };

    getTitle = () => (
        <Row
            style={{
                direction: "flex",
                flexDirection: "row",
                justifyContent: "space-between"
            }}>
            <Col span={12}>{"Document Review"}</Col>
            <Col
                span={12}
                style={{
                    justifyContent: "flex-end",
                    display: "flex",
                    paddingRight: "50px"
                }}>
                <Button onClick={this.sendNotification} type={"primary"}>
                    Send Notification
                </Button>
            </Col>
        </Row>
    );

    requestDocSearch=event => {
        this.setState({
            requestDocSearchQuery: event.target.value
        });
    }

    filterDocumentCategory = (doc) => {
        return this.state.requestDocSearchQuery? doc.document_name && doc.document_name.toLocaleLowerCase().includes(this.state.requestDocSearchQuery.toLocaleLowerCase()):true;
    }

    createNewDocument = (blob) => {
        let newBlob = blob;
        const file = new File([newBlob], this.state.selectedFile.file_name, {type: blob.type, lastModified: new Date()});
        const formData = new FormData();
        formData.append("file", file);
        formData.append("company", this.props.companyId);
        formData.append("file_name", this.state.selectedFile.file_name);
        formData.append("parent_document_master", this.state.selectedFile.id);
        formData.append("file_mime", blob.type);
        this.props.uploadDocument(this.props.caseId, this.props.companyId, formData);
        this.updateDocument("DELETE", this.state.selectedFile.set("is_active", false), null, null);
    }

    closeRequestRemarksModal = () => {
        this.setState({
            showRequestedRemarks: false,
            requestedRemarks: null 
        });
    }
    scrollPositionFunc = (val, searchFilterArr) => {
        scrollPositionValue = val;
        this.setState({searchFilterVals:searchFilterArr});
    }
    handleApplicantSelectModal=() => {
        this.setState({
            document : [],
            requestedDocs : [],
            requestedApplicantDocs  : [],
            filteredAadharBoth : [],
            filterOtherDocuments : [],
            applicantSelectModal : !this.state.applicantSelectModal
        });
    }

    onSelectApplicantForRequestedDoc = (docId, associate , docRemarks = "") => {
        let alreadyAdded = this.state.document.find(_ => _.id == docId);
        if(alreadyAdded && alreadyAdded.id){
            this.setState({
                document : this.state.document.filter(_ => _.id != docId)} , () => {
                this.setState({
                    document : [...this.state.document , {
                        id : docId,
                        associate : associate ? associate : undefined,
                        request_remarks : docRemarks ? docRemarks : undefined
                    }]
                });
            });
        }else{
            this.setState({
                document : [...this.state.document , {
                    id : docId,
                    associate : associate ? associate : undefined,
                    request_remarks : docRemarks ? docRemarks : undefined
                }]
            });
        }
    }

    requestApplicantDocumentsHandler = () => {
        const allRequestedDocs = [...this.state.requestedDocs];
        let documents_associate = this.state.document.map(_ => {
            if(_.id.toString().includes("-")){
                _.document_option_id =  parseInt(_.id.split("-")[1]);
                _.id = parseInt(_.id.split("-")[0]);
            }else{
                _;
            }
            return _;
        });
        this.handleApplicantSelectModal();
        this.setState({
            requestModal : false,
            requestedApplicantDocs : [],
        } , () => {
            let data = {
                document : documents_associate,
                documents : allRequestedDocs.filter(_ => !applicantDocuments[_] && !applicantAadharBoth[_] && !otherDocuments[_])
            };
            this.props.requestDocuments(
                this.props.caseId,
                this.props.companyId,
                data,
                true
            );
            this.setState({
                document : [],
                requestedDocs : [],
            });
        });
    }

    selectApplicantModal = () => {
        const {requestedApplicantDocs , filteredAadharBoth , filterOtherDocuments} = this.state;
        const filteredRequestRemarks = this.state.document.filter(_ => _.request_remarks != null && _.request_remarks != "");
        return <Modal
            visible={this.state.applicantSelectModal}
            onCancel={this.handleApplicantSelectModal}
            title={"Select Applicant/Document Name"}
            onOk={this.requestApplicantDocumentsHandler}
            className={"doc-checkboxes"}
            width={"40vw"}
            height={"80vh"}
            okButtonProps={{ disabled: filteredRequestRemarks.some(_ => _.request_remarks.length < 5 ) }}
            bodyStyle={{
                maxHeight: "500px",
                overflowY: "scroll"
            }}>
            {requestedApplicantDocs.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{applicantDocuments[_]}</p>
                <Select
                    className={"fb-50"}
                    style={{
                        minWidth: "200px"
                    }}
                    size={"small"}
                    dropdownMatchSelectWidth={false}
                    onChange={(val) => this.onSelectApplicantForRequestedDoc(_ , val , "")}
                >
                    {this.props.associates.map((_, k) => (
                        <Select.Option key={k} value={_ && _.id}>
                            {`${_ && _.first_name} ${_ && _.last_name}`}
                        </Select.Option> 
                    )).toList()}
                </Select>
            </Col>)}
            {filteredAadharBoth.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{applicantAadharBoth[_]}</p>
                <Select
                    className={"fb-50"}
                    style={{
                        minWidth: "200px"
                    }}
                    size={"small"}
                    dropdownMatchSelectWidth={false}
                    onChange={(val) => this.onSelectApplicantForRequestedDoc(_ , val , "")}
                >
                    {this.props.associates.map((_, k) => (
                        <Select.Option key={k} value={_ && _.id}>
                            {`${_ && _.first_name} ${_ && _.last_name}`}
                        </Select.Option> 
                    )).toList()}
                </Select>
            </Col>)}
            {filterOtherDocuments.map((_ , key) => <Col key={key} span={24} style={{
                paddingTop: "2px",
                paddingBottom: "2px"
            }} className={"d-flex justify-content-space-between"}>
                <p>{otherDocuments[_]}</p>
                <FormItem help={filteredRequestRemarks.some(_ => _.request_remarks.length < 5 ) ? "Minimum Characters should be 5" : ""}>
                    <TextArea 
                        rows={2}
                        placeholder="Enter document name"
                        onChange={(e) =>this.onSelectApplicantForRequestedDoc(_ , "", e.target.value)}
                        className={"fb-50"}
                        minLength={5}
                        style={{
                            minWidth: "200px"
                        }}/>
                </FormItem>
            </Col>)}
        </Modal>;
    }


    onAddCustomer = (type, associateId) => {
        if (this.state.selectedAgent[associateId] && this.state.selectedCaller[associateId]) {
            this.setState({
                isGeneratingLink: { ...this.state.isGeneratingLink, [`${type}_${associateId}`]: true },
                showAddCustomerStatus: true,
                showAddCustomerText: "Pending..."
            });
            CompanyService.addCustomer(this.props.caseId, associateId, this.state.selectedAgent[associateId], this.state.selectedCaller[associateId])
            .then(({ data }) => {
                this.setState({
                    vkycTransactionId: data.transactionId,
                    showAddCustomerText: "Customer Added Successfuly",
                });
                this.props.fetchCaseAssociates(this.props.caseId);
                // <Alert message={"Customer Added Successfuly"} />;
                if (data && data.success) {
                    message.success("VKYC Link Generated Successfully");
                }
            }).catch((err) => {
                this.setState({
                    showAddCustomerStatus: false,
                    showAddCustomerText: err && Object.values(err) && Object.values(err)[0] || "Something went wrong",
                });
                message.error(err || err && err.non_field_errors && err.non_field_errors[0] || err.message || "Something went wrong")
            }).finally(() => {
                this.setState({ isGeneratingLink: { ...this.state.isGeneratingLink, [`${type}_${associateId}`]: false } });
            })
        } else {
            let errMessage = "";
            if(!this.state.selectedAgent[associateId]){
                errMessage = "Please select the agent name"
            }else if(!this.state.selectedCaller[associateId]){
                errMessage = "Please select the caller name"
            }
            message.error(errMessage);
        }
    }

    notifyUser = (transactionId, associate_id, type) => {
        this.setState({ isGeneratingLink: {...this.state.isGeneratingLink, [`${type}_${associate_id}`]: true} });
        CompanyService.vkycSendEmail(transactionId).then(res=>{
            if(res?.data?.msg?.code === "SUCCESS"){
                message.success("SUCCESS");
            }
        }).catch(err=>{
            message.error("Something went wrong")
        }).finally(() => {
            this.setState({ isGeneratingLink: {...this.state.isGeneratingLink, [`${type}_${associate_id}`]: false} });
        });
    }

    onVkycEmail = () => {
        this.setState({
            showEmailStatus: true,
            showEmailText: "Pending..."
        });
        CompanyService.vkycGetData(this.props.caseId).then(({data})=>{
            if(data.results[0].transaction_id !== ""){
                CompanyService.vkycSendEmail(data.results[0].transaction_id).then(({res})=>{
                    this.setState({
                        showEmailText: "Email sent successfuly."
                    });
                }).catch(() => {
                    this.setState({
                        showEmailText: "Something went wrong"
                    });
                });
            }else{
                this.setState({
                    showEmailText: "Please add customer first."
                });
            }
        }).catch(() => {
            this.setState({
                showEmailText: "Something went wrong"
            });
        });
    }

    onVkycRefresh = (associateId, videCall, vkycView, isAgentName) => {
        CompanyService.vkycGetData(this.props.caseId, associateId, isAgentName).then(({data})=>{
            let response = data?.results && data?.results[0];
            if (videCall && response && response.vkyc_video_link) {
                window.open(response.vkyc_video_link, '_blank');
            }else if(videCall && response?.vkyc_video_link === undefined) {
                message.error("NO KYC video Available");
            }
            if(isAgentName){
                this.setState({agentName: { ... this.state.agentName, [associateId]: response?.agent || "--"}});
            }
            if(vkycView){
            this.setState({
                vkycViewData: response?.json_data || null,
                showVkycDetail: true
                })
            }
            if(response?.call_status !== null){
                this.setState({
                    vkycStatus: response?.call_status || "Yet to Initiate",
                });
            }
        }).catch(err=>{
            message.error("Something went wrong");
        })
    }

    showVkyvDetailModal=()=>{
        this.setState({
            showVkycDetail: true
        });
    }

    vkycTableColumns = () => {
        const columns = [
            {
                title: <p><b>Name</b></p> ,
                dataIndex: 'send_vkyc_link_name',
                key: 'send_vkyc_link_name',
                align: "center", width: 100,
              },
            {
                title: "Agent Name" ,
                dataIndex: 'agent_name',
                key: 'agent_name',
                align: "center", width: 100,
              },
            {
                title: "Caller Name" ,
                dataIndex: 'caller_name',
                key: 'caller_name',
                align: "center", width: 100,
              },
            {
              title: <p><b>Send VKYC link</b><span><Tooltip title={this.state.vkycTransactionId?"New Customer will be added after link expired":"Please add customer to generate vkyc link"}>
                    <Icon style={{ fontSize: 8, verticalAlign: "text-top", marginTop: 2 }} type="info-circle" />
                </Tooltip></span></p> ,
              dataIndex: 'send_vkyc_link',
              key: 'send_vkyc_link',
              align: "center", width: 100,
            },
            {
              title: "Status of VKYC",
              dataIndex: "status_vkyc",
              key: 'status_vkyc',
              align: "center", width: 100,
            },
            {
              title: "VKYC Details",
              dataIndex: 'vkyc_details',
              key: 'vkyc_details',
              align: "center", width: 100,
            },
            {
              title: "VKYC Link",
              dataIndex: 'vkyc_link',
              key: 'vkyc_link',
              align: "center", width: 100,
            },
            {
              title: "Video Link",
              dataIndex: 'video_link',
              key: 'video_link',
              align: "center", width: 100,
            },
          ];

          return columns;
    }

    vkycTableData = () => {
        const dataSource = this.props.caseAssociates && this.props.caseAssociates?.filter(associate => [1, 2].includes(associate.type)).map((_, k) => {
            const agentDropdown = <Select
                style={{
                    width: "200px",
                    marginTop: '1rem'
                }}
                // disabled={_.vkyc?.weblink}
                onChange={(val) =>
                    this.setState(prevState => ({
                        selectedAgent: { ...prevState.selectedAgent, [_.id]: val }
                    }))
                }
                value={this.state.selectedAgent[_.id] || null}
            >
                {this.state.vkycUsers?.map(el => (
                    <Select.Option key={el.id} value={el.id}>
                        {`${el.first_name} ${el.last_name}`}
                    </Select.Option>
                ))}
            </Select>;
            const callerDropdown = <Select
                style={{
                    width: "200px",
                    marginTop: '1rem'
                }}
                // disabled={_.vkyc?.weblink}
                onChange={(val) =>
                    this.setState(prevState => ({
                        selectedCaller: { ...prevState.selectedCaller, [_.id]: val }
                    }))
                }
                value={this.state.selectedCaller[_.id] || null}
            >
                {this.state.vkycUsers?.map(el => (
                    <Select.Option key={el.id} value={el.id}>
                        {`${el.first_name} ${el.last_name}`}
                    </Select.Option>
                ))}
            </Select>
            return (
                {
                    key: k + 1,
                    send_vkyc_link_name: <span style={{ fontWeight: "600", color: "black" }}>
                        {`${_.company_associate && _.company_associate.first_name || ""} ${_.company_associate && _.company_associate.last_name || ""}`}
                    </span>,
                    agent_name: _.vkyc?.weblink && _?.vkyc?.is_link_expired !== true ?
                        <> {this.state.agentName[_.id] || <Button className={"ant-btn ant-btn-primary"} onClick={() => this.onVkycRefresh(_.id, false, "", true)}> Agent Name</Button>} {process.env.VKYC_REGENERATE_USER_EMAIL.includes(this.props.userDetails?.email) && agentDropdown}</>
                        : <>{agentDropdown}</>,
                    caller_name: <>{callerDropdown}</>,
                    send_vkyc_link: <div key={k} className={"d-flex mt-5 p-5 mb-5 d-flex justify-content-center align-items-center w-100"} >
                        {_?.vkyc?.is_link_expired !== false ? <Button className={"ant-btn ant-btn-primary"} onClick={() => this.onAddCustomer('generate', _.id)} loading={this.state.isGeneratingLink[`generate_${_.id}`]}>
                            Generate Link
                        </Button> :
                            <div>
                                <Button
                                    style={{ width: "9rem" }}
                                    className={"ant-btn ant-btn-primary"}
                                    onClick={() => this.notifyUser(_?.vkyc?.transaction_id, _.id, 'send')}
                                    loading={this.state.isGeneratingLink[`send_${_.id}`]}
                                >
                                    Send Link
                                </Button>
                                {process.env.VKYC_REGENERATE_USER_EMAIL.includes(this.props.userDetails?.email) && <Button style={{ marginTop: "1rem", width: "9rem" }} className={"ant-btn ant-btn-primary"} onClick={() => this.onAddCustomer('regenerate', _.id)} loading={this.state.isGeneratingLink[`regenerate_${_.id}`]}>
                                    Re-Generate Link
                                </Button>}
                            </div>
                        }
                    </div>,
                    status_vkyc: <div>
                        <span>
                            {this.state.vkycStatus}
                        </span>
                        <Icon type={"sync"} style={{ color: _.vkyc?.weblink ? "#1890ff" : "grey", marginLeft: "1rem" }} onClick={() => { return (_.vkyc?.weblink ? this.onVkycRefresh(_.id) : null) }} />
                    </div>
                    ,
                    vkyc_details: <Button className={"ant-btn ant-btn-primary"} onClick={() => this.onVkycRefresh(_.id, false, "vkycView")} disabled={!_.vkyc?.weblink}>
                        View
                    </Button>,
                    vkyc_link: <Button className={"ant-btn ant-btn-primary"}
                        disabled={!_.vkyc?.weblink}
                    >
                        <a href={_?.vkyc?.weblink} target="_blank" rel="noopener noreferrer"> <span style={{ color: _?.vkyc?.weblink ? "#ffff" : "#cacaca" }}> Link For VKYC Page </span> </a>
                    </Button>,
                    video_link: <Button className={"ant-btn ant-btn-primary"} onClick={() => this.onVkycRefresh(_.id, "videCall")} disabled={!_.vkyc?.weblink}>
                        VKYC Video Link
                    </Button>,
                }
            )
        }).toList().toArray();
        return dataSource;
    }

    render() {
        this.groupedDocMasterList =
            this.props.docMasterList &&
            this.props.docMasterList.length &&
            new List(this.props.docMasterList).groupBy(
                item => item.document_category && item.document_category.name
            ).map(_ => _.filter(this.filterDocumentCategory))
                .filter(_ => _.size > 0);


        const {vkycViewData} = this.state;
        return (
            <React.Fragment>
                {this.selectApplicantModal()}
                <Modal
                    style={{minWidth: "80%"}}
                    visible={this.state.showVkycDetail}
                    title={<p style={{textAlign: "center", margin: 0, fontSize: "20px", fontWeight: "bold"}}>Hytone Holding Pvt. Ltd</p>}
                    onCancel={()=>this.setState({showVkycDetail: false})}
                    footer={[
                        <Button key="submit" onClick={() => this.setState({showVkycDetail: false})} >
                            Close
                        </Button>,
                    ]}
                >
                    {
                        vkycViewData ? <>
                        <Row>
                            <Col xs={2} sm={12} md={12} lg={12} xl={12}>
                                <div style={{display: "grid"}}>
                                    <span><b>KYC Report</b></span>
                                    <span><b>Customer Name:</b> {vkycViewData?.applicationDetails?.firstName + " " + vkycViewData?.applicationDetails?.lastName} | <b>Application Id - </b>{vkycViewData?.applicationId} | <b>Customer Id -</b>{vkycViewData?.customerId}</span>
                                    <span><b>Agent Name:</b> {vkycViewData?.actionLog && vkycViewData?.actionLog.length > 0 && vkycViewData?.actionLog[vkycViewData?.actionLog.length - 1]?.agentName} </span>
                                </div>
                            </Col>
                            <Col xs={20} sm={12} md={12} lg={12} xl={12}>
                                <div style={{display: "grid"}}>
                                    <span><b>Transaction Id: </b>{vkycViewData.transactionId}</span>
                                    <span><b>Call Start Timestamp:</b> {vkycViewData.callStartTime}</span>
                                    <span><b>Call End Timestamp:</b> {vkycViewData.callEndTime}</span>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col style={{padding: "5px", boxShadow: "0px -1px 0 0 #e8e8e8 inset"}}>
                                <Row style={{textAlign: "center", padding: "10px", fontSize: "16px", fontWeight: "bold", background: "#f7f7f7"}}>
                                Customer Detail
                                </Row>
                                <table style={{width: "100%", marginTop: "2%"}}>
                                    <tr>
                                        <th>User Detail</th>
                                        <th>Applicant Form Data</th>
                                        <th>Aadhar Data</th>
                                        <th>PAN details {vkycViewData?.panMatchResults?.panID?.value}</th>
                                        <th>Match</th>
                                    </tr>
                                    <tr>
                                        <td><b>NAME</b></td>
                                        <td>{vkycViewData?.applicationDetails?.firstName + " " + vkycViewData?.applicationDetails?.lastName}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.name?.value}</td>
                                        <td>{vkycViewData?.panMatchResults?.name?.value}</td>
                                        <td>{vkycViewData?.kycReport?.name?.overAllScore}</td>
                                    </tr>
                                    <tr>
                                        <td><b>FATHER'S NAME</b></td>
                                        <td>{vkycViewData?.applicationDetails?.fatherName}</td>
                                        <td></td>
                                        <td>{vkycViewData?.panMatchResults?.fathersName?.value}</td>
                                        <td></td>
                                        <td>{vkycViewData?.kycReport?.fathersName?.overAllScore}</td>
                                    </tr>
                                    <tr>
                                        <td><b>DOB</b></td>
                                        <td>{vkycViewData?.applicationDetails?.dob}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.dob?.value}</td>
                                        <td>{vkycViewData?.panMatchResults?.dob?.value}</td>
                                        <td>{vkycViewData?.kycReport?.dob?.overallMatch?"Yes":"No"}</td>
                                    </tr>
                                    <tr>
                                        <td><b>GENDER</b></td>
                                        <td>{vkycViewData?.applicationDetails?.gender}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.gender?.value}</td>
                                        <td></td>
                                        <td>{vkycViewData?.kycReport?.gender?.overallMatch?"Yes":"No"}</td>
                                    </tr>
                                    <tr>
                                        <td><b>CURRENT ADDRESS</b></td>
                                        <td>{vkycViewData?.applicationDetails?.addrCurr}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.currentAddress?.value}</td>
                                        <td></td>
                                        <td>{vkycViewData?.kycReport?.currentAddress?.overAllScore}</td>
                                    </tr>
                                    <tr>
                                        <td><b>PERMANENT ADDRESS</b></td>
                                        <td>{vkycViewData?.applicationDetails?.addrPerm}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.permanentAddress?.value}</td>
                                        <td></td>
                                        <td>{vkycViewData?.kycReport?.permanentAddress?.overAllScore}</td>
                                    </tr>
                                    <tr>
                                        <td><b>MOBILE NUMBER</b></td>
                                        <td>{vkycViewData?.applicationDetails?.phone}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.phone?.value}</td>
                                        <td>{vkycViewData?.panMatchResults?.phone?.value}</td>
                                        <td>{vkycViewData?.kycReport?.phone?.overallMatch?"Yes":"No"}</td>
                                    </tr>
                                    <tr>
                                        <td><b>EMAIL</b></td>
                                        <td>{vkycViewData?.applicationDetails?.email}</td>
                                        <td>{vkycViewData?.aadhaarMatchResults?.email?.value}</td>
                                        <td>{vkycViewData?.panMatchResults?.email?.value}</td>
                                        <td>{vkycViewData?.kycReport?.email?.overallMatch?"Yes":"No"}</td>
                                    </tr>
                                </table>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2} sm={12} md={12} lg={12} xl={12} style={{padding: "5px", boxShadow: "0px -1px 0 0 #e8e8e8 inset"}}>
                                <Row style={{textAlign: "center", padding: "10px", fontSize: "16px", fontWeight: "bold", background: "#f7f7f7"}}>
                                    Browser & IP Details
                                </Row>
                                <table style={{width: "100%", marginTop: "2%"}}>
                                    <tr>
                                        <td><b>Browser Name</b></td>
                                        {vkycViewData?.browserAndIpDetails?.browserType}
                                    </tr>
                                    <tr>
                                        <td><b>Browser Version</b></td>
                                        {vkycViewData?.browserAndIpDetails?.browserVersion}
                                    </tr>
                                    <tr>
                                        <td><b>Operating System</b></td>
                                        {vkycViewData?.browserAndIpDetails?.operatingSystem}
                                    </tr>
                                </table>
                            </Col>
                            <Col xs={2} sm={12} md={12} lg={12} xl={12} style={{padding: "5px", boxShadow: "0px -1px 0 0 #e8e8e8 inset"}}>
                                <Row style={{textAlign: "center", padding: "10px", fontSize: "16px", fontWeight: "bold", background: "#f7f7f7"}}>
                                    Liveliness Check
                                </Row>
                                <table style={{width: "100%", marginTop: "2%"}}>
                                    <tr>
                                        <th><b>Question Asked</b></th>
                                        {/* <th><b>Remarks</b></th> */}
                                        <th><b>Result</b></th>
                                    </tr>
                                    {
                                    vkycViewData?.questions && vkycViewData?.questions.length > 0 && vkycViewData?.questions?.map((item) => {
                                        return (
                                            <>
                                            <tr>
                                                <td>
                                                    {item.question}
                                                </td>
                                                {/* <td>
                                                    {item.remarks}
                                                </td> */}
                                                <td>
                                                    {item.pass?"Correct":"Incorrect"}
                                                </td>
                                            </tr>
                                            </>
                                        );
                                    })
                                    }
                                </table>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={2} sm={12} md={12} lg={12} xl={12} style={{padding: "5px", boxShadow: "0px -1px 0 0 #e8e8e8 inset"}}>
                                <Row style={{textAlign: "center", padding: "10px", fontSize: "16px", fontWeight: "bold", background: "#f7f7f7"}}>
                                    Customer Detail
                                </Row>
                                <table style={{width: "100%", marginTop: "2%"}}>
                                    <tr>
                                        <td><b>latitude</b></td>
                                        <td>{vkycViewData?.location?.latitude}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Longitude</b></td>
                                        <td>{vkycViewData?.location?.longitude}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Post Code</b></td>
                                        <td>{vkycViewData?.location?.postcode}</td>
                                    </tr>
                                    <tr>
                                        <td><b>City</b></td>
                                        <td>{vkycViewData?.location?.city}</td>
                                    </tr>
                                    <tr>
                                        <td><b>District</b></td>
                                        <td>{vkycViewData?.location?.stateDistrict}</td>
                                    </tr>
                                    <tr>
                                        <td><b>State</b></td>
                                        <td>{vkycViewData?.location?.state}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Country</b></td>
                                        <td>{vkycViewData?.location?.country}</td>
                                    </tr>
                                    <tr>
                                        <td><b>IP Address</b></td>
                                        <td>{vkycViewData?.ipAddress}</td>
                                    </tr>
                                </table>
                            </Col>
                            <Col xs={2} sm={12} md={12} lg={12} xl={12} style={{padding: "5px", boxShadow: "0px -1px 0 0 #e8e8e8 inset"}}>
                                <Row style={{textAlign: "center", padding: "10px", fontSize: "16px", fontWeight: "bold", background: "#f7f7f7"}}>
                                    Verifying Agent's Remarks
                                </Row>
                                <table style={{width: "100%", marginTop: "2%"}}>
                                    <tr>
                                        <th><b>Section</b></th>
                                        <th><b>Remarks</b></th>
                                    </tr>
                                    {
                                    vkycViewData?.summary && vkycViewData?.summary.length > 0 && vkycViewData?.summary.map((item) => {
                                        return (
                                            <tr>
                                                <td>{item.key}</td>
                                                <td>{item.isSuccess?"Approved":"Not Approved"}</td>
                                            </tr>
                                        );
                                    })
                                    }
                                </table>
                                <Row style={{textAlign: "center", padding: "10px", fontSize: "16px", fontWeight: "bold", background: "#f7f7f7"}}>
                                    Verifying Agent's Status
                                </Row>
                                <table style={{width: "100%", marginTop: "2%"}}>
                                    <tr>
                                        <td><b>Remarks</b></td>
                                        <td><b>{vkycViewData?.agentKycStatusRemark}</b></td>
                                    </tr>
                                </table>
                            </Col>
                        </Row>
                        </> :
                         <>
                            <div className="d-flex justify-content-center align-items-center"> No Details Available
                            </div>
                        </>
                    }
                </Modal>
                <Modal
                    visible={this.state.requestModal}
                    onCancel={this.closeRequestModal}
                    title={"Request Documents"}
                    destroyOnClose
                    onOk={this.requestDocumentsHandler}
                    className={"doc-checkboxes"}
                    width={"40vw"}
                    height={"80vh"}
                    bodyStyle={{
                        maxHeight: "500px",
                        overflowY: "scroll"
                    }}>
                    <Input.Search onChange={this.requestDocSearch} placeholder={"Type Document Name to search"} />
                    <Checkbox.Group
                        style={{
                            width: "100%"
                        }}
                        // value={this.state.requestedDocs}
                        onChange={this.onChangeRequestDocs}
                    >
                        {this.groupedDocMasterList &&
                        this.groupedDocMasterList.size ?
                            this.groupedDocMasterList.filter((obj , k) => k !=  "Progcap Others")
                                .map((_, k) => (
                                    <React.Fragment key={`${k}-item`}>
                                        <Divider
                                            orientation={"left"}
                                            key={`${k}-divider`}>
                                            {" "}
                                            {k}{" "}
                                        </Divider>
                                        <Row>
                                            {_
                                                .map(__ => (
                                                    <Col span={12} key={__.id}>
                                                        {__.document_document_type_option.length > 0 ? __.document_document_type_option.map(docOption =>  <Checkbox
                                                            className={"fb-50"}
                                                            key={docOption.id}
                                                            value={`${__.id}-${docOption.id}`}>
                                                            {docOption.document_type_name}
                                                        </Checkbox>): <Checkbox
                                                            className={"fb-50"}
                                                            key={__.id}
                                                            value={__.id}>
                                                            {__.document_name}
                                                        </Checkbox>}
                                                        
                                                    </Col>
                                                ))}
                                        </Row>

                                    </React.Fragment>
                                ))
                                .toList()
                                .toArray():null}
                    </Checkbox.Group>
                </Modal>
                <Modal
                    visible={this.state.showRequestedRemarks}
                    title={"Add Request Remarks"}
                    destroyOnClose
                    onOk={this.sendRequestToDocument}
                    onCancel={this.closeRequestRemarksModal}
                >
                    <Input.TextArea onChange={(e) => {
                        this.setState({
                            requestedRemarks: e.target.value
                        });
                    }} value={this.state.requestedRemarks} />
                </Modal>
                {/* {this.state.openDrawer && (
                    <Drawer
                        visible={this.state.openDrawer}
                        title={this.getTitle()}
                        height={"100vh"}
                        width={"100vw"}
                        className={"view-drawer"}
                        placement={"right"}
                        closable={true}
                        destroyOnClose={true}
                        onClose={this.toggleDrawer}> */}
                <div tabIndex={0} onKeyDown={this.onKeyUp}>
                    <Layout className={"doc-review-layout"}>
                        <Layout.Content>
                            <Row>
                                <Col
                                    span={24}
                                    style={{
                                        justifyContent: "flex-end",
                                        display: "flex",
                                        paddingTop: "25px",
                                        paddingRight: "20px"
                                    }}
                                >
                                    <Button onClick={this.sendNotification} disabled={this.props.recreditViewOnlyPermission} type={"primary"}>
                                        Send Notification
                                    </Button>
                                </Col>
                            </Row>
                            <Row
                                className={
                                    "d-flex h-100 p-5 base-layout-row"
                                }>
                                <Col
                                    span={7}
                                    className={"doc-list p-5"}>

                                    <DocumentViewList
                                        associates={
                                            this.props.associates
                                        }
                                        caseId={this.props.caseId}
                                        files={this.props.files}
                                        viewDoc={this.viewDoc}
                                        selectedFileId={
                                            this.state.selectedFile &&
                                            this.state.selectedFile.id
                                        }
                                        stageId={this.props.stageId}
                                        addRequestedRemark={this.addRequestedRemark}
                                        companyId={this.props.companyId}
                                        uploadFiles={this.props.uploadDocuments.bind(
                                            null,
                                            this.props.caseId,
                                            this.props.companyId
                                        )}
                                        filesStatus={
                                            this.props.filesStatus
                                        }
                                        scrollPositionProp={this.scrollPositionFunc}
                                        searchFilterVals={this.state.searchFilterVals}
                                        changeName={this.changeName}
                                        openRequestModal={
                                            this.openRequestModal
                                        }
                                        noDocumentDeletePerm={this.props.noDocumentDeletePerm}
                                        categoryList={
                                            (this.props.docMasterList && new List(this.props.docMasterList)
                                                .toMap()
                                                .mapEntries(
                                                    ([,v]) => [v.document_name, v.document_name]
                                                )
                                                .toList().toArray())
                                                || []
                                        }
                                        docMasterListStatus={
                                            this.props
                                                .docMasterListStatus
                                        }
                                        deleteRequestedDocument={
                                            this.deleteRequestedDocument
                                        }
                                        fetchFiles={this.handleFilesFetch.bind(this , true)}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                    />
                                </Col>
                                <Col span={17}>
                                    <SignzyDataForm
                                        fileType={
                                            this.state.selectedFileType
                                        }
                                        filePath={
                                            this.state.selectedFilePath
                                        }
                                        file={this.props.files.find(_ => _.id === (this.state.selectedFile && this.state.selectedFile.id))}
                                        documentType={this.getDocumentType()}
                                        associates={
                                            this.props.associates
                                        }
                                        bankAccounts={this.props.bankAccounts}
                                        docMasterList={
                                            this.state.docMaster
                                        }
                                        companyId={this.props.companyId}
                                        updateDocument={
                                            this.updateDocument
                                        }
                                        addressesList={
                                            this.props.addressesList
                                        }
                                        parseData={this.parseDocument}
                                        createNewDocument={this.createNewDocument}
                                        recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                        caseId={this.props.caseId}
                                        fetchFiles={this.handleFilesFetch.bind(this , true)}
                                    />
                                </Col>
                            </Row>
                        </Layout.Content>
                    </Layout>
                </div>
                <div>
                    {
                    // ((this.props.stage?.toJS().stage_name == "Progcap Credit" || this.props.stage?.toJS().stage_name == "Progcap PS Kit Review") && isProperitorship == "Proprietorship" && this.state.isVkycRequired) &&
                        <Row style={{padding: "0 0 20px 1rem"}}>
                            <Col
                                span={24}
                                style={{
                                    // justifyContent: "flex-end",
                                    display: "flex",
                                    padding: "20px 0px 0px 20px"
                                }}
                            >
                                <h1>VIDEO KYC Details</h1>
                            </Col>
                            <Row style={{width:"80%"}}>
                                        <Table
                                            bordered 
                                            columns={this.vkycTableColumns()}
                                            dataSource={this.vkycTableData()}
                                            pagination={false}
                                            // scroll={{ y: 240 }}
                                            size="middle"
                                        />
                                        {/* <Col
                                            span={24}
                                            style={{
                                                justifyContent: "left",
                                                display: "grid",
                                                padding: "0px 0px 0px 20px"
                                            }}
                                        >
                                            <Button className={"ant-btn ant-btn-primary"} disabled={!(!this.props.recreditViewOnlyPermission && !(this.state.vkycTransactionId?true:false))} onClick={() => this.onAddCustomer()}>
                                        Add Customer
                                            </Button>
                                            <span style={{paddingTop: "10px"}}>
                                                {
                                                    this.state.showAddCustomerStatus && this.state.showAddCustomerText
                                                }
                                            </span>
                                        </Col> */}
                                {/* <Col span={4}>
                                    <Row>
                                        <Col
                                            span={24}
                                            style={{
                                                // justifyContent: "left",
                                                padding: "20px 0px 0px 20px"
                                            }}
                                            className="d-flex justify-content-center"
                                        >
                                            <p><b>Status of VKYC</b></p>
                                        </Col>
                                        <Col
                                            span={24}
                                            style={{
                                                display: "flex",
                                                padding: "0px 0px 0px 20px"
                                            }}
                                        >
                                            <Button className={"ant-btn ant-btn-primary"}>
                                                {this.state.vkycStatus}
                                            </Button>
                                            <Button style={{marginLeft: "10px"}} onClick={() => this.onVkycRefresh()} disabled={this.props.recreditViewOnlyPermission}>
                                                <Icon type={"sync"} onClick={() => this.onVkycRefresh()} />
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col> */}
                                {/* {
                                    vkycViewData && Object.keys(vkycViewData).length !== 0 && <Col span={6}>
                                        <Row>
                                            <Col
                                                span={24}
                                                style={{
                                                    justifyContent: "left",
                                                    display: "flex",
                                                    padding: "20px 0px 0px 20px"
                                                }}
                                            >
                                                <p><b>VKYC Details</b></p>
                                            </Col>
                                            <Col
                                                span={24}
                                                style={{
                                                    justifyContent: "left",
                                                    display: "flex",
                                                    padding: "0px 0px 0px 20px"
                                                }}
                                            >
                                                <Button className={"ant-btn ant-btn-primary"} onClick={() => this.showVkyvDetailModal()}>
                                            View
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Col>
                                } */}
                                {/* {
                                    this.state.vkycTransactionId ? <Col span={6}>
                                        <Row>
                                            <Col
                                                span={24}
                                                style={{
                                                    justifyContent: "left",
                                                    display: "flex",
                                                    padding: "20px 0px 0px 20px"
                                                }}
                                            >
                                                <p><b>Communication Details</b></p>
                                            </Col>
                                            <Col
                                                span={24}
                                                style={{
                                                    justifyContent: "left",
                                                    display: "grid",
                                                    padding: "0px 0px 0px 20px"
                                                }}
                                            >
                                                <Button className={"ant-btn ant-btn-primary"} onClick={() => this.onVkycEmail()} disabled={this.props.recreditViewOnlyPermission}>
                                            Send Email
                                                </Button>
                                                <span style={{paddingTop: "10px"}}>
                                                    {
                                                this.state.vkycViewDetail?.vkyc_link
                                                    }
                                                </span>
                                                <span style={{paddingTop: "10px"}}>
                                                    {
                                                        this.state.showEmailStatus && this.state.showEmailText
                                                    }
                                                </span>
                                            </Col>
                                        </Row>
                                    </Col>:null
                                } */}
                            </Row>
                        </Row>
                    }
                </div>
                {/* </Drawer>
                )} */}
                {/* <div className={"doc-review-btn"}>
                    <Button type={"dashed"} onClick={this.toggleDrawer}>
                        Open Document Reviewer
                    </Button>
                </div> */}
            </React.Fragment>
        );
    }
}

DocumentReviewTabV2.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    files: PropTypes.object,
    filesStatus: PropTypes.string,
    fetchCompanyDocuments: PropTypes.func,
    uploadDocuments: PropTypes.func,
    updateDocument: PropTypes.func,
    fetchDocumentTypes: PropTypes.func,
    fetchApplicantsList: PropTypes.func,
    associatesStatus: PropTypes.string,
    associates: PropTypes.array,
    bankAccounts: PropTypes.array,
    docMasterListStatus: PropTypes.string,
    docMasterList: PropTypes.array,
    companyDocStatus: PropTypes.string,
    validateDocument: PropTypes.func,
    invalidateDocument: PropTypes.func,
    updateCompanySingleAssociate: PropTypes.func,
    requestDocuments: PropTypes.func,
    addressesList: PropTypes.object,
    failedValidateDocument: PropTypes.func,
    failedInvalidateDocumentStatus: PropTypes.func,
    attachDocument: PropTypes.func,
    parseDocument: PropTypes.func,
    panParsedData: PropTypes.object,
    userDetails: PropTypes.object,
    aadhaarParsedData: PropTypes.object,
    sendRequest: PropTypes.func,
    uploadDocument: PropTypes.func,
    addRequestRemarks: PropTypes.func,
    stageId: PropTypes.number,
    noDocumentDeletePerm: PropTypes.bool,
    fetchCaseDetail: PropTypes.func,
    recreditViewOnlyPermission: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    return({
    uploads: state.documents.getIn(["uploads", props.companyId]),
    companyDocStatus:state.documents.getIn(["caseV2Documents"]),
    companyDocStatusPrevios:state.documents.getIn(["company_documents"]),
    caseDetail: state.caseDetails.getIn([Number(props.caseId), "data"]),
    caseAssociates: state.caseDetails.getIn([Number(props.caseId), "caseAssociates", "data"]),
    docMasterListStatus: state.documents.getIn([
        "documentsMasterList",
        "status"
    ]),
    docMasterList: state.documents.getIn(["documentsMasterList", "data"]),
    associates: state.companies.getIn([
        props.companyId,
        "data",
        "associates"
    ], Map({})),
    associatesStatus: state.documents.getIn([
        props.companyId,
        "status",
        "associatesStatus"
    ], STATE_STATUS.UNFETCHED),
    addressesList: state.companies.getIn([
        props.companyId,
        "data",
        "addresses"
    ]),
    bankAccounts: state.companies.getIn([
        props.companyId,
        "data",
        "bank_accounts"
    ]),
    files: state.documents
        .getIn(["caseV2Documents", props.companyId, "data"], Map({}))
        .map(_ => _.get("data"))
        .filter(_ => _.is_active)
        .sort((a, b) => (a.modified_date.isBefore(b.modified_date) ? 1 : -1))
        .toList(),
    filesStatus: state.documents.getIn(
        ["caseV2Documents", props.companyId, "status"],
        STATE_STATUS.UNFETCHED
    ),
    panParsedData: state.documents.getIn([
        "parsedData",
        props.companyId,
        "pan"
    ]),
    aadhaarParsedData: state.documents.getIn([
        "parsedData",
        props.companyId,
        "aadhaar"
    ]),
    noDocumentDeletePerm: state.user.getIn(["permissions", "cannot_delete_document"]),
    stage: state.stages
        .get("data")
        .find(_ => _.id === props.stageId),
    company:
        props.companyId
            ? state.companies.getIn([props.companyId, "data"])
            : null,
    userDetails : state.user.getIn(["data"]),
})};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCompanyDocuments,
            updateDocument,
            uploadDocuments,
            fetchDocumentTypes,
            fetchApplicantsList,
            invalidateDocument,
            validateDocument,
            requestDocuments,
            attachDocument,
            parseDocument,
            sendRequest,
            uploadDocument,
            failedValidateDocument,
            failedInvalidateDocumentStatus,
            fetchCaseDetail,
            addRequestRemarks,
            fetchCaseAssociates,
            fetchDocumentsCaseV2
        },
        dispatch
    );

const WrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentReviewTabV2);
export default PermissionContextManager({
    permission: UI_PERMISSIONS.DOCUMENTS_VIEW,
    propsPermissions: {
        DOCUMENTS_EDIT: UI_PERMISSIONS.DOCUMENTS_EDIT
    }
})(WrappedComponent);
